import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function ProductDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`http://localhost:4000/api/admin/products/${id}/full`, {
      headers: {
        Authorization: "Bearer demo-0f5aa001-82ab-4cc8-819d-8dd412fd30b9"
      }
    })
      .then(res => res.json())
      .then(json => {
        setData(json);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div>Cargando producto...</div>;
  if (!data?.ok) return <div>Error cargando producto</div>;

  const { product, prices, systems, tools, assets, editorials, ai_flows } = data;

  return (
  <main
    style={{
      maxWidth: 1000,
      margin: "2rem auto",
      fontFamily: "Questrial, sans-serif",
    }}
  >
    {/* Header */}
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "1rem",
        marginBottom: "1.5rem",
        flexWrap: "wrap",
      }}
    >
      <div>
        <div style={{ marginBottom: 10 }}>
          <a
            href="/admin/productos"
            style={{
              textDecoration: "none",
              color: "#286b94",
              fontWeight: 700,
              fontSize: "0.9rem"
            }}
          >
            ← Volver a Productos
          </a>
        </div>

        <h1
          style={{
            margin: 0,
            fontFamily: "Bitter, serif",
            fontSize: 28,
            color: "#0a2230",
            fontWeight: 800,
          }}
        >
          {product.name}
        </h1>
        
        <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
          <span
            style={{
              border: "1px solid #e6ebf1",
              background: "#fafafa",
              padding: "6px 10px",
              borderRadius: 999,
              color: "#2c3b51",
              fontSize: "0.8rem",
              fontWeight: 700,
              textTransform: "uppercase"
            }}
           >
            {product.product_type}
          </span>

          <span
            style={{
              border: "1px solid #e6ebf1",
              background: "#fff",
              padding: "6px 10px",
              borderRadius: 999,
              color: "#6b7a88",
              fontSize: "0.8rem",
              fontWeight: 700,
              textTransform: "uppercase"
            }}
          >
            {product.status}
          </span>

          <span
            style={{
              border: "1px solid #e6ebf1",
              background: product.is_active ? "#e8f5e9" : "#fff",
              padding: "6px 10px",
              borderRadius: 999,
              color: product.is_active ? "#2e7d32" : "#6b7a88",
              fontSize: "0.8rem",
              fontWeight: 700,
              textTransform: "uppercase"
            }}
          >
            {product.is_active ? "Activo" : "Inactivo"}
          </span>
        </div>

        <p
          style={{
            margin: "0.35rem 0 0",
            color: "#6b7a88",
            fontSize: "0.95rem",
          }}
        >
          {product.description || "Sin descripción"}
        </p>
      </div>
    </header>

    {/* Información básica */}
    <section
      style={{
        border: "1px solid #e6ebf1",
        borderRadius: 14,
        padding: 16,
        background: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,.05)",
        marginBottom: 20,
      }}
    >
      <h3 style={{ marginTop: 0 }}>Información</h3>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <div><strong>Tipo:</strong> {product.product_type}</div>
        <div><strong>Status:</strong> {product.status}</div>
        <div><strong>Activo:</strong> {product.is_active ? "Sí" : "No"}</div>
        <div><strong>Stripe ID:</strong> {product.stripe_product_id || "—"}</div>
      </div>
    </section>

    {/* Precios */}
    <section
      style={{
        border: "1px solid #e6ebf1",
        borderRadius: 14,
        padding: 16,
        background: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,.05)",
        marginBottom: 20,
      }}
    >
      <h3 style={{ marginTop: 0 }}>Precios</h3>

      {prices.length === 0 ? (
        <p>No tiene precios</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              prices.length > 1 ? "repeat(auto-fit, minmax(220px, 1fr))" : "1fr",
            gap: 12
          }}
        >
          {[...prices]
            .sort((a, b) => a.display_order - b.display_order)
            .map(p => (
            <div
              key={p.id}
              style={{
                border: "1px solid #e6ebf1",
                borderRadius: 12,
                padding: "16px",
                background: p.is_recommended ? "#eef6ff" : "#fafafa",
                position: "relative"
              }}
            >
              {p.is_recommended && (
                <div
                  style={{
                    position: "absolute",
                    top: -10,
                    right: 12,
                    background: "#286b94",
                    color: "#fff",
                    fontSize: "0.75rem",
                    fontWeight: 800,
                    padding: "4px 8px",
                    borderRadius: 999
                   }}
                >
                  RECOMENDADO
                </div>
              )}

              <div style={{ fontSize: 14, fontWeight: 700, color: "#6b7a88" }}>
                {p.label || "Precio"}
              </div>

              <div style={{ fontSize: 24, fontWeight: 900, color: "#0a2230", marginTop: 6 }}>
                ${(p.amount / 100).toFixed(2)}
              </div>

              <div style={{ marginTop: 4, fontSize: "0.9rem", color: "#6b7a88" }}>
                {p.currency.toUpperCase()} · {p.interval || "one_time"}
              </div>

              {p.marketing_note && (
                <div style={{ marginTop: 8, fontSize: "0.85rem", color: "#2c3b51" }}>
                  {p.marketing_note}
                </div>
              )}
            </div>
          ))}
         </div>
      )}
    </section>

    {/* Asociaciones (ocultar si membership) */}
    {product.product_type !== "membership" && (
      <section
        style={{
          border: "1px solid #e6ebf1",
          borderRadius: 14,
          padding: 16,
          background: "#fff",
          boxShadow: "0 10px 30px rgba(0,0,0,.05)",
        }}
      >
        <h3 style={{ marginTop: 0 }}>Asociaciones</h3>

        <div style={{ marginBottom: 10 }}>
          <strong>Systems</strong>
          {systems.map(s => <div key={s.id}>{s.name}</div>)}
        </div>

        <div style={{ marginBottom: 10 }}>
          <strong>Tools</strong>
          {tools.map(t => <div key={t.id}>{t.name}</div>)}
        </div>

        <div style={{ marginBottom: 10 }}>
          <strong>Assets</strong>
          {assets.map(a => <div key={a.id}>{a.name}</div>)}
        </div>

        <div style={{ marginBottom: 10 }}>
          <strong>Editorials</strong>
          {editorials.map(e => <div key={e.id}>{e.name}</div>)}
        </div>

        <div>
          <strong>AI Flows</strong>
          {ai_flows.map(f => <div key={f.id}>{f.name}</div>)}
        </div>
      </section>
    )}
  </main>
);
}